import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import {
  changeActive,
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  FailTogenerateCredentialMsg,
  generateCredentialMsg,
  noInternetMsg,
  saveFailedMsg,
  sendCredentialMsg,
  serverMsg,
  statusmsg,
} from "../../../config/messageconstant";
import { stackHolderJson } from "../../../DynamicFormsJson/MastersJSON/StackHolder";
import { getAreaByTalukaPostBodyUpdated } from "../../../Slice/area.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import {
  getStockholderByAreaIdsForFilterPost,
  getStockStakeHolderByOrderExist,
  getUpdatedStackHolderOptimized,
} from "../../../Slice/StackHolder.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { StakeHolderColumns } from "../../../tableColumns/table-columns";
import { apiDelete, apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import { downloadF } from "../../PDF/PDFDownload";
import OrderToExistPopUp from "./OrderToExistPopUp";
class StackHolder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLog: true,
      moduleObjDataObj: {},
      showFilterDataExcel: "",
      isDistributorInactiveSaveInLog: "",
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
      },
      tabValue: 1,
      orderToExistPopUp: false,
      moduleObjDataObj: {},
      isLog: true,
      rows: [],
      selectedRowData: {},
      dynamicMasterData: {
        stackHolderListInActive:
          this.props.stackHolderByAreaList?.stackholder.filter(
            (row) => row.isActive == 0
          ),
        stackHolderListActive:
          this.props.stackHolderByAreaList?.stackholder.filter(
            (row) => row.isActive == 1
          ),
      },
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: StakeHolderColumns,
          showExcelDownload: true,
          changeExcelURL: "stock-holder-data-new",
          isActionColActive: true,
          value: "stackHolderListActive",
          searchList: stackHolderJson.searchList,
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: StakeHolderColumns,
          showExcelDownload: true,
          changeExcelURL: "stock-holder-data-new",
          isActionColActive: true,
          value: "stackHolderListInActive",
          searchList: stackHolderJson.searchList,
        },
      ],
    };
  }
  async componentDidMount() {
    const { showNotification } = this.props;
    if (navigator.onLine) {
      const moduleObjData = localStorage.getItem("moduleObj");
      const moduleObjDataObj =
        moduleObjData != null ? JSON.parse(moduleObjData) : {};

      const showFilterDataExcel = localStorage.getItem(
        "showFilterDataWiseExcel"
      );

      if (showFilterDataExcel && showFilterDataExcel == 1) {
        this.setState((prevState) => ({
          tabList: prevState.tabList.map((tab) => ({
            ...tab,
            showExcelDownload: false,
          })),
        }));
      }

      const isDistributorInactiveSaveInLog = localStorage.getItem(
        "isDistributorInactiveSaveInLog"
      );

      this.setState({
        showFilterDataExcel,
        moduleObjDataObj,
        isDistributorInactiveSaveInLog,
      });

      await this.getList();
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stackHolderByAreaList !== nextProps.stackHolderByAreaList) {
      if (
        this.props.stackHolderByAreaList?.stackholder !==
        nextProps.stackHolderByAreaList?.stackholder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stackHolderListActive: nextProps.stackHolderByAreaList?.stackholder
              .filter((row) => row.isActive == 1)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
            stackHolderListInActive:
              nextProps.stackHolderByAreaList?.stackholder
                .filter((row) => row.isActive == 0)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
          },
        });
      }
    }
  }

  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };

  getList = async () => {
    const {
      getUpdatedStackHolderOptimized,
      showLoador,
      showNotification,
      getRegionNew,
    } = this.props;
    showLoador({ loador: true });
    await getRegionNew().then(({ success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      }
    });
    showLoador({ loador: true });
    await getUpdatedStackHolderOptimized().then(({ success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      }
    });
  };
  
  onSearchData = async (data) => {
    const {
      getStockholderByAreaIdsForFilterPost,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      let stockHolderJson = {
        areaIds: data.areaIds,
      };
      showLoador({ loador: true });
      await getStockholderByAreaIdsForFilterPost({
        areaIds: stockHolderJson,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  onClickApply = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { moduleObjDataObj, isLog } = this.state;

    swal({
      title: "Are you sure?",
      text: sendCredentialMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          showLoador({ loador: true });
          apiGet({
            url: endpoint.stackholder + "/" + rowData.id + "/password-reset",
          }).then(({ success }) => {
            if (success) {
              if (isLog) {
                if (rowData !== null) {
                  let updatedJsonToSend = JSON.stringify(rowData);

                  let dataToSaveForMLog = {
                    module: {
                      moduleId: moduleObjDataObj.moduleId,
                    },
                    subModule: {
                      subModuleId: moduleObjDataObj.subModuleId,
                    },
                    operationType: 1,
                    type: 1,
                    operationPerformId: rowData.id,
                    updatedJson: updatedJsonToSend,
                  };

                  showLoador({ loador: true });
                  apiPost({
                    url: endpoint.mlog,
                    postBody: dataToSaveForMLog,
                  }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (success) {
                    } else {
                      showNotification({
                        msg: saveFailedMsg,
                        severity: "error",
                      });
                    }
                  });
                }
              }

              showLoador({ loador: false });
              showNotification({
                msg: generateCredentialMsg,
              });
            } else {
              showNotification({
                msg: FailTogenerateCredentialMsg,
                severity: "error",
              });
              showLoador({ loador: false });
            }
          });
        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    });
  };

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBodyUpdated,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      console.log(data);
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zoneIds && data.zoneIds != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zoneIds }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaIdsJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaIdsJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { isLog, moduleObjDataObj, selectedRowData } = this.state;

    if (selectedRowData.isActive == 1) {
      if (navigator.onLine) {
        swal({
          title: "Are you sure?",
          text: changeActive,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((value) => {
          if (value) {
            showLoador({ loador: true });
            apiPost({
              url:
                endpoint.stackholder +
                "/make-active-inactive?stockStakeHolderId=" +
                selectedRowData.id +
                "&areaId=" +
                "&flag=0",
              postBody: {},
            }).then(async ({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
                if (isLog) {
                  if (selectedRowData !== null) {
                    let updatedJsonToSend = JSON.stringify(selectedRowData);

                    let dataToSaveForMLog = {
                      module: {
                        moduleId: moduleObjDataObj.moduleId,
                      },
                      subModule: {
                        subModuleId: moduleObjDataObj.subModuleId,
                      },
                      operationType: 1,
                      type: 1,
                      operationPerformId: selectedRowData.id,
                      updatedJson: updatedJsonToSend,
                    };

                    showLoador({ loador: true });
                    await apiPost({
                      url: endpoint.mlog,
                      postBody: dataToSaveForMLog,
                    }).then(({ success }) => {
                      showLoador({ loador: false });
                      if (success) {
                      } else {
                        showNotification({
                          msg: saveFailedMsg,
                          severity: "error",
                        });
                      }
                    });

                    if (this.state.isDistributorInactiveSaveInLog == 1) {
                      const dataToSaveForLog = {
                        stockStakeHolderId: selectedRowData.id,
                        areaId: selectedRowData.areaIds,
                      };
                      await apiPost({
                        url: endpoint.inActiveStockStkHolderLogs,
                        postBody: dataToSaveForLog,
                      }).then(({ success }) => {
                        showLoador({ loador: false });
                        if (success) {
                        } else {
                          showNotification({
                            msg: saveFailedMsg,
                            severity: "error",
                          });
                        }
                      });
                    }
                  }
                }
                showNotification({ msg: statusmsg });
                this.handleCloses();
                this.getList();
              }
            });
          }
        });
      } else {
        this.props.showNotification({ msg: noInternetMsg, severity: "error" });
      }
    } else {
      localStorage.setItem(
        "stockHolderTableData",
        JSON.stringify(selectedRowData)
      );
      this.props.navigate("/stackholder-change-status/" + selectedRowData.id);
    }
  };

  onChangeStatus = (rowData) => {
    const { showLoador, showNotification, getStockStakeHolderByOrderExist } =
      this.props;
    const { isLog, moduleObjDataObj } = this.state;

    this.setState({ selectedRowData: rowData });

    if (rowData.isActive == 1) {
      showLoador({ loador: true });
      getStockStakeHolderByOrderExist({
        stockStakeHolderId: rowData.id,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          if (response.length !== 0) {
            this.setState({
              orderToExistPopUp: true,
            });
          } else {
            if (navigator.onLine) {
              swal({
                title: "Are you sure?",
                text: changeActive,
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((value) => {
                if (value) {
                  showLoador({ loador: true });
                  apiPost({
                    url:
                      endpoint.stackholder +
                      "/make-active-inactive?stockStakeHolderId=" +
                      rowData.id +
                      "&areaId=" +
                      "&flag=0",
                    postBody: {},
                  }).then(async ({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                      if (isLog) {
                        if (rowData !== null) {
                          let updatedJsonToSend = JSON.stringify(rowData);

                          let dataToSaveForMLog = {
                            module: {
                              moduleId: moduleObjDataObj.moduleId,
                            },
                            subModule: {
                              subModuleId: moduleObjDataObj.subModuleId,
                            },
                            operationType: 1,
                            type: 1,
                            operationPerformId: rowData.id,
                            updatedJson: updatedJsonToSend,
                          };

                          showLoador({ loador: true });
                          await apiPost({
                            url: endpoint.mlog,
                            postBody: dataToSaveForMLog,
                          }).then(({ success }) => {
                            showLoador({ loador: false });
                            if (success) {
                            } else {
                              showNotification({
                                msg: saveFailedMsg,
                                severity: "error",
                              });
                            }
                          });

                          if (this.state.isDistributorInactiveSaveInLog == 1) {
                            const dataToSaveForLog = {
                              stockStakeHolderId: rowData.id,
                              areaId: rowData.areaIds,
                            };
                            await apiPost({
                              url: endpoint.inActiveStockStkHolderLogs,
                              postBody: dataToSaveForLog,
                            }).then(({ success }) => {
                              showLoador({ loador: false });
                              if (success) {
                              } else {
                                showNotification({
                                  msg: saveFailedMsg,
                                  severity: "error",
                                });
                              }
                            });
                          }
                        }
                      }
                      showNotification({ msg: statusmsg });
                      this.getList();
                    }
                  });
                }
              });
            } else {
              this.props.showNotification({
                msg: noInternetMsg,
                severity: "error",
              });
            }
          }
        }
      });
    } else {
      localStorage.setItem("stockHolderTableData", JSON.stringify(rowData));
      this.props.navigate("/stackholder-change-status/" + rowData.id);
    }
  };

  onClickTransfer = (rowData) => {
    const { showLoador, showNotification } = this.props;
    swal({
      title: "Are you sure?",
      text: "Do You Want To Active Status For Stock Holder ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    });
  };

  rowEdit = (rowData) => {
    this.props.navigate("/stock-holder-edit/" + rowData.id);
  };

  rowView = (rowData) => {
    this.props.navigate(stackHolderJson.formPathView + "/" + rowData.id);
  };

  generateStaticExcelMethod = () => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    downloadF({
      url: endpoint.exportData + "/" + stackHolderJson.excelUrl,
      ext: "xls",
      openNewTab: true,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        this.props.showNotification({
          msg: serverMsg,
          severity: "error",
        });
      } else {
      }
    });
  };

  rowAnalytics = (rowData) => {
    let stockHolderData = JSON.stringify(rowData);
    localStorage.setItem("stockHolderDetails", stockHolderData);
    this.props.navigate("/stock-holder-analytics" + "/" + rowData.id);
  };

  rowStructure = (rowData) => {
    this.props.navigate(
      "/stake-holder-rate-structure-details-view" + "/" + rowData.id
    );
  };

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (rowData.id) {
          showLoador({ loador: true });
          apiDelete({
            url: endpoint.stackholder + "/" + rowData.id,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              if (data && data.data && data.data.statusCode == 200) {
                showNotification({ msg: deletemsg });
                window.location.reload();
              } else {
                showNotification({ msg: deleteFailedMsg, severity: "error" });
              }
            } else {
              showNotification({
                msg: serverMsg,
                severity: "error",
              });
            }
          });
        }
      }
    });
  };

  handleCloses = () => {
    this.setState({
      orderToExistPopUp: false,
    });
  };

  render() {
    const { stackHolderByAreaList } = this.props;
    const {
      dynamicMasterData,
      tabList,
      showFilterDataExcel,
      orderToExistPopUp,
    } = this.state;

    const isShowSendCredentialIcon =
      localStorage.getItem("isShowSendCredentialIcon") !== null ? localStorage.getItem("isShowSendCredentialIcon") : 1;

    return (
      <>
        <DynamicTabwiseTable
          dynamicMasterData={dynamicMasterData}
          searchList={stackHolderJson.searchList}
          formPath={stackHolderJson.formPath}
          formPathView={stackHolderJson.formPathView}
          getListById={this.getListById}
          screenTitle={stackHolderJson.screenTitle}
          fieldMeta={stackHolderJson.fieldMeta}
          showPdfDownload={stackHolderJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          filterDataExcel={true}
          pdfFileName={stackHolderJson.pdfFileName}
          excelFileName={stackHolderJson.excelFileName}
          showAddButton={stackHolderJson.showAddButton}
          tableColumnsToFilter={stackHolderJson.tableColumnsToFilter}
          tableColumns={StakeHolderColumns}
          tableData={stackHolderByAreaList?.stackholder}
          apiBaseURL={stackHolderJson.apiBaseURL}
          callApi={false}
          isActiveURL={stackHolderJson.isActiveURL}
          showAddButtonInTable={true}
          onClickAdd={this.onClickAdd}
          openFormPath={stackHolderJson.openFormPath}
          searchButtonGrid={stackHolderJson.searchButtonGrid}
          getTableDataById={true}
          onSearchData={this.onSearchData}
          getTableData={this.getList}
          tabList={tabList}
          generateStaticExcelMethod={this.generateStaticExcelMethod}
          changeExcelURL={stackHolderJson.excelUrl}
          isNote={true}
          isNoteValue={"Add Stock Holder & Details"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          rowStatusTrue={true}
          rowStatus={this.onChangeStatus}
          showHeadEdit={true}
          staticEdit={true}
          deleteStaticTrue={true}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          rowDelete={this.rowDelete}
          showPegination={true}
          showApplyCredintial={isShowSendCredentialIcon == 1 ? true : false}
          showView={true}
          rowEdit={this.rowEdit}
          showTransferButtonInTable={true}
          showCreditCardButtonInTable={
            localStorage.getItem("showStockHolderStructureDetails") &&
            localStorage.getItem("showStockHolderStructureDetails") == 1
              ? true
              : false
          }
          onClickTransfer={this.onClickTransfer}
          rowApply={this.onClickApply}
          openFormPathStatus={stackHolderJson.openFormPathStatus}
          showTransferButtonTitle={"Assign Structure"}
          showAnalyticsButtonInTable={
            localStorage.getItem("showAnalyticsIcon") &&
            localStorage.getItem("showAnalyticsIcon") == 1
              ? true
              : false
          }
          rowAnalytics={this.rowAnalytics}
          rowStructure={this.rowStructure}
        />

        {orderToExistPopUp && (
          <OrderToExistPopUp
            open={orderToExistPopUp}
            handleCloses={this.handleCloses}
            onSubmit={this.onSubmit}
            selectedRowData={this.state.selectedRowData}
            columns={[
              {
                title: "Sr. No.",
                name: "index",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "center",
              },
              {
                title: "User Name",
                name: "userName",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "center",
                canSearch: "true",
              },
              {
                title: "Owner Name",
                name: "name",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "left",
                canSearch: "true",
              },
              {
                title: "Firm Name",
                name: "firmName",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "left",
                canSearch: "true",
              },
              {
                title: "Type",
                name: "stockStakeHolderTypeName",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "left",
                canSearch: "true",
              },
              {
                title: "Status",
                name: "isActive",
                alignCenter: "center",
                showInscreen: true,
                positionCenter: true,
                canSearch: "true",
              },
            ]}
            rows={stackHolderByAreaList?.stockHolderOrderExistList}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  stackHolderByAreaList: state.stockholder,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getZoneByState,
  getRegionNew,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBodyUpdated,
  getStockholderByAreaIdsForFilterPost,
  getStateByRegion,
  getUpdatedStackHolderOptimized,
  getStockStakeHolderByOrderExist,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StackHolder);
